import { render, staticRenderFns } from "./TaskFlow.vue?vue&type=template&id=4818e032&"
import script from "./TaskFlow.vue?vue&type=script&lang=js&"
export * from "./TaskFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports